

const settingReducer = (state = "color", action) => {

    switch(action.type){
        case "setSetting":
            return action.payload
        default:
            return state
    }
} 

export default settingReducer